let validations = {
	validateLength: validateLength,
	validateEmail: validateEmail,
	validateRequired: validateRequired,
	validateImageRequired: validateImageRequired,
	validateFileType: validateFileType,
	validateFileSize: validateFileSize,
	validateRadioRequired: validateRequired,
	validateSelectRequired: validateSelectRequired,
	validateEndDateRequired: validateEndDateRequired,
	validateInputGroupRequired: validateInputGroupRequired,
	validateSelectGroupRequired: validateSelectGroupRequired,
	validateLink: validateLink,
	validateLinkUrl: validateLinkUrl,
	validateTestimonial: validateTestimonial,
	validatePeriod: validatePeriod,
	validateRatioAndSize: validateRatioAndSize,
	validateRepeatingUrl: validateRepeatingUrl,
	validateLinkKeywordLength: validateLinkKeywordLength
}

export function validateField(formData, field){
	let isFieldValid = true;
	formData[field].errors = [];
	formData[field].validations.forEach(validation => {
		if(typeof validations[validation.type] !== 'function'){
			console.error('Validation type not found: ' + validation.type);
			return;
		}
		validations[validation.type]({input: formData[field].value, errors: formData[field].errors, formData, field, ...validation});
	})

	if (formData[field].errors.length > 0) {
		isFieldValid = false;
		if(formData[field].ref?.$el){
			formData[field].ref?.$el.scrollIntoView({behavior: 'smooth'});
		}else{
			formData[field].ref?.scrollIntoView({behavior: 'smooth'});
		}

	}
	return isFieldValid;
}

export function validateLinkKeywordLength({input, max, errors, message}){
	if(validateParams({max, errors, message})){
		console.error('Error validating link keyword length');
		return;
	}
	if(input.length === 0){
		return;
	}
	input.forEach((item) => {
		if(item.link && item.link.trim().length > max){
			errors.push(message);
		}
	})
}

export function validateRepeatingUrl({input, errors, message}){
	if(validateParams({input, errors, message})){
		console.error('Error validating repeating url');
		return;
	}
	if(input.length === 0){
		return;
	}
	let urls = [];
	input.forEach(item => {
		if(item.url && item.url.trim() !== ''){
			if(urls.includes(item.url)){
				errors.push(message);
			}else{
				urls.push(item.url);
			}
		}
	})

}

export function validateSelectGroupRequired({input, required, message, errors, formData}){
	if(validateParams({required, message, errors, formData})){
		console.error('Error validating select group required');
		return;
	}
	if(required){
		if(input.length === 0){
			errors.push(message);
		}else{
			let anythingSelected = false;
			for(let i in input){
				if(input[i] !== undefined && (input[i]?.length > 0 || typeof input[i]?.id !== 'undefined')){
					anythingSelected = true;
					return;
				}
			}
			if(!anythingSelected){
				errors.push(message);
			}
		}
	}
}

export function validateRatioAndSize({input, minWidth, maxWidth, minHeight, maxHeight, minRatio, maxRatio, errors, message, formData, field}){
	if(validateParams({minWidth, minHeight, minRatio, maxRatio, errors, message})){
		console.error('Error validating ratio and size');
		return;
	}

	if(!input || typeof input === 'string'){
		errors.filter(el => el !== message);
		return;
	}

	const width = formData[field]?.ref?.width || formData[field]?.ref?.[0]?.width;
	const height = formData[field]?.ref?.height || formData[field]?.ref?.[0]?.height;
	if(!width || !height){
		return;
	}

	const ratio = width / height;

	if (width < minWidth || height < minHeight || ratio < minRatio || ratio > maxRatio || width > maxWidth || height > maxHeight) {
		errors.push(message);
	}
}

export function validatePeriod({message, formData}){
	formData.endMonth.errors = formData.endMonth.errors.filter(el => el !== message)
	if(formData.isOngoingProject.value){
		return;
	}else{
		if(formData.startYear.value[0].id && formData.startMonth.value[0].id && formData.endYear.value[0].id && formData.endMonth.value[0].id){
			if(formData.startYear.value[0].id > formData.endYear.value[0].id) {
				formData.endMonth.errors.push(message);
				return;
			}else if(formData.startYear.value[0].id === formData.endYear.value[0].id){
				if(formData.startMonth.value[0].id > formData.endMonth.value[0].id){
					formData.endMonth.errors.push(message);
					return;
				}
			}
		}
		return;
	}
}

export function validateTestimonial({input, errors, message}){
	if(validateParams({errors, message})){
		errors.push(message);
		console.error('Error validating testimonial');
		return;
	}
	if(input.length === 0){
		return;
	}
	input.forEach(item => {
		if(item.name === '' && item.jobRole === '' && item.quote === ''){
			//if its required, write check here
		}else if(item.name === '' || item.jobRole === '' || item.quote === ''){
			errors.push(message);
			return;
		}
	})
}

export function validateLinkUrl({input, errors, message}){
	if(validateParams({errors, message})){
		console.error('Error validating link url');
		return;
	}
	if(input.length === 0){
		return;
	}
	input.forEach(item => {
		if(item.url ){
			let urlRegex = /^(http|https):\/\/[^ "]+$/;
			if(!urlRegex.test(item.url)){
				errors.push(message);
				return;
			}
		}
	})
}

export function validateLink({input, errors, message}){
	if(validateParams({errors, message})){
		errors.push(message);
		console.error('Error validating link');
		return;
	}

	if(input.length === 0){
		return;
	}
	input.forEach(item => {
		if(item.link === '' && item.url === ''){
			//if its required, write check here
		}else if(item.link === '' || item.url === ''){
			errors.push(message);
			return;
		}
	})
}
export function validateInputGroupRequired({input, required, message, errors, formData}){
	if(validateParams({required, message, errors, formData})){
		console.error('Error validating input group required');
		return;
	}
	if(required){
		if(input.length === 0){
			if(errors.indexOf(message) === -1){
				errors.push(message);
			}
			return;
		}
		for(let i = 0; i < input.length; i++){
			Object.keys(input[i]).forEach(key => {
				if(input[i][key] === '') {
					if(errors.indexOf(message) === -1){
						errors.push(message);
					}
					return;
				}
			});
		}
	}
}
export function validateEmail({input, errors, message}){
	if(validateParams({errors, message})){
		console.error('Error validating email');
		return;
	}
	if(!input){
		return;
	}
	let newInput = input.trim();
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	if(!emailRegex.test(newInput)){
		errors.push(message);
	}
}

export function validateEndDateRequired({input, required, message, errors, formData}){
	if(validateParams({required, message, errors, formData})){
		console.error('Error validating end date required');
		return;
	}
	if(formData.isOngoingProject.value){
		return;
	}
	if((!input || input?.length === 0) && required){
		errors.push(message);
	}
}

export function submissionValidate(formData) {
	let newFormData = {...formData};
	if (newFormData?.isOngoingProject?.value) {
		newFormData.endYear.errors = [];
		newFormData.endYear.value = [];
		newFormData.endMonth.errors = [];
		newFormData.endMonth.value = [];
	}

	let isFormValid = true;
	Object.keys(newFormData).forEach(key => {
		if ((key === 'endYear' || key === 'endMonth') && newFormData?.isOngoingProject?.value){
			return; // skip validation for end date if project is ongoing
		} else {
			isFormValid = validateField(newFormData, key) && isFormValid
		}
	});
	return isFormValid;
}

function validateImageRequired({input, required, errors, message}){
	if(!input){
		if(required){
			errors.push(message);
		}
		return;
	}else if(typeof input === 'string'){
		return;
	}

	const file = input.get('file');
	if(!file){
		if(required){
			errors.push(message);
		}
		return;
	}
	if(validateParams({file, required, errors, message})){
		console.error('Error validating image required');
		errors.push(message);
		return;
	}
}
function validateFileType({input, allowedTypes, errors, message}){
	if(!input || typeof input === 'string'){
		return;
	}

	let file = input.get('file');
	if(!file){
		return;
	}
	if(validateParams({file, allowedTypes, errors, message})){
		console.error('Error validating file type');
		errors.push(message);
		return;
	}
	if(!allowedTypes.includes(file.type)){
		errors.push(message);
	}
}
function validateFileSize({input, maxFileSize, errors, message}){
	if(!input || typeof input === 'string'){
		return;
	}

	let file = input.get('file');
	if(!file){
		return;
	}
	if(validateParams({file, maxFileSize, errors, message})){
		console.error('Error validating file size');
		return;
	}
	if(file.size > maxFileSize) {
		errors.push(message);
	}
}

function validateParams(params) {
	let hasError = false;
	Object.keys(params).forEach(key => {
			if (typeof params[key] === "undefined" || params[key] === null) {
				console.error('Missing required parameter: ' + key);
				hasError = true;
			}
	})

	return hasError
}
function validateLength({input, min, max, message, errors}){
	if(validateParams({min, max, message, errors})){
		console.error('Error validating length');
		return;
	}

	if(input.trim().length < min || input.trim().length > max){
		errors.push(message);
	}
}

function validateSelectRequired({input, required, message, errors}){
	if(validateParams({required, message, errors})){
		console.error('Error validating select required');
		return;
	}
	if((!input || input.length === 0 || !input[0] || input[0].length === 0) && required){
		errors.push(message);
	}
}
function validateRequired({input, required, message, errors}){
	if(validateParams({required, message, errors})){
		console.error('Error validating required');
		errors.push(message);
		return;
	}

	if(!input && required){
		errors.push(message);
		return;
	}

	if (typeof input === "string" && input.trim() === '' && required) {
		errors.push(message);
		return;
	}

	if (typeof input === "object" && Object.keys(input).length === 0 && required) {
		errors.push(message);
		return;
	}
}
